<ion-list class="ion-padding" lines="none">
  <ion-label style="font-size: large; font-weight: bold;">Inserisci il tuo nome da mostrare alla community</ion-label>
  <ion-item class="ion-padding-vertical">
    <ion-input (keypress)="dismissKeyboard($event)" placeholder="Mario Rossi" [(ngModel)]="userName" autocapitalize="words"></ion-input>
  </ion-item>
  <ion-button [disabled]="!userName" expand="block" size="large" style="margin-bottom: 32px;" (click)="save()">
    SALVA E CONTINUA
  </ion-button>
</ion-list>